/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_UndoInputs */

const en_common_undo = /** @type {(inputs: Common_UndoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Undo`)
};

const fr_common_undo = /** @type {(inputs: Common_UndoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annuler`)
};

const de_common_undo = /** @type {(inputs: Common_UndoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rückgängig machen`)
};

const it_common_undo = /** @type {(inputs: Common_UndoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disfare`)
};

const ru_common_undo = /** @type {(inputs: Common_UndoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отменить`)
};

const es_common_undo = /** @type {(inputs: Common_UndoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deshacer`)
};

const zh_cn2_common_undo = /** @type {(inputs: Common_UndoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`撤销`)
};

const ja_common_undo = /** @type {(inputs: Common_UndoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`元に戻す`)
};

const hi_common_undo = /** @type {(inputs: Common_UndoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पूर्ववत`)
};

const pt_pt2_common_undo = /** @type {(inputs: Common_UndoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desfazer`)
};

/**
* | output |
* | --- |
* | "Undo" |
*
* @param {Common_UndoInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const common_undo = /** @type {((inputs?: Common_UndoInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_UndoInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_common_undo(inputs)
	if (locale === "de") return de_common_undo(inputs)
	if (locale === "it") return it_common_undo(inputs)
	if (locale === "ru") return ru_common_undo(inputs)
	if (locale === "es") return es_common_undo(inputs)
	if (locale === "zh-CN") return zh_cn2_common_undo(inputs)
	if (locale === "ja") return ja_common_undo(inputs)
	if (locale === "hi") return hi_common_undo(inputs)
	if (locale === "pt-PT") return pt_pt2_common_undo(inputs)
	return en_common_undo(inputs)
});